import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { MedicalHistory } from '../../master/model/medical-history' ;
import { Patient } from '../model/patient';
import { PatientService } from '../service/patient-service.service';
import { MedicalHistoryService } from '../../master/services/medical-history.service'; 
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { error } from 'selenium-webdriver';
@Component({
  selector: 'app-create-patient',
  templateUrl: './create-patient.component.html',
  styleUrls: ['./create-patient.component.css']
})
export class CreatePatientComponent implements OnInit {
  patient : Patient = new Patient(null,'','','','',null,'','','','','',null,null,'',null,'','','','',null,null,'',0);
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  selectedObject : Patient;
  filesData: any;
  text:string;
  profilePic : any;
  isAdd : boolean = true;
  history : MedicalHistory[];
  isErrorMessage : boolean = false;
  isSuccessMessage : boolean = false;
  dobDate:{};
  myDatePickerOptions: IMyDpOptions = {
    // other options...
  dateFormat: 'dd/mm/yyyy',
  
};
  constructor(private _sharedService: SharedService, private _ptService : PatientService, private _hsSrv : MedicalHistoryService) {
    this.isAdd = true;
   }
    savePatient() : void {
      if(this.patient.MedicalHistoryId === null) {
      //  this.message = "Please select medical history!";
      //  this.isErrorMessage  =true;
      //  this.hideMessage() ;
      this.patient.MedicalHistoryId = 0;
          // return;
      }
    this.loading = true;
    this._ptService.data = this.patient;
    if(this.isAdd){
      this.addPatient();
    } 
}
hideMessage() : void {
  setTimeout(() => {
    this.isErrorMessage  = false;
    this.isSuccessMessage  = false;   
    this.message = '';
  }, 2000);
};
onChange(event: EventTarget) {
  let eventObj: MSInputMethodContext = <MSInputMethodContext> event;
  let target: HTMLInputElement = <HTMLInputElement> eventObj.target;
  let files: FileList = target.files;
  this.profilePic = files[0];
  this.text = files[0].name;
  
}
onDateChanged(event: IMyDateModel) {
  //debugger;
  
  if(event.date != null && event.date.year != 0) {
    this.patient.PatientDOB= event.date.year + '-' + event.date.month + '-'+ event.date.day;
    
      var date1 = this.patient.PatientDOB;
      let dt = new Date();       
      let date2 = dt.getFullYear()+"-"+(dt.getMonth() + 1)+"-" + dt.getDate();
      
        let dateParts1 = date1.split('-');
        let dateParts2 = date2.split('-');
        let  d1 : any = new Date(parseInt(dateParts1[0]), parseInt(dateParts1[1])-1, parseInt(dateParts1[2]))
        let d2 : any = new Date(parseInt(dateParts2[0]), parseInt(dateParts2[1])-1, parseInt(dateParts2[2]))
    
      this.patient.PatientAge= new Date(d2 - d1).getFullYear() - new Date(0).getFullYear();
   
    
  }
  else {
    //this.message = 'Please select appointment date!'; 
    //this.isErrorMessage = true;
    return;
  }
}
close() {

}

addPatient() :void {   
    this.loading = true; 
    this.isErrorMessage  = false;
    this.isSuccessMessage  = false;   
    this._ptService.savePatient().subscribe(data=>{
      this.loading = false;
      this._ptService.data.PatientId = data.PatientId;
      if(this._ptService.profilePic !== undefined && this._ptService.profilePic !== null){
        this.filesData = [];
        this.filesData.push(this.profilePic );
        this._ptService.profilePic = this.filesData;
        this._ptService.savePatientProfile().subscribe(data=>{
          this.message = "User "+ ActionMessage.SAVESUCCESS.toString();
          this.getPatients();
          this.clearData();
          this.isSuccessMessage  =true;
          this.hideMessage() ;
        },error=>{
          this.message = "User "+ ActionMessage.SAVESUCCESS.toString();
          this.clearData();
          this.getPatients();
          this.isSuccessMessage  =true;
          this.hideMessage() ;
        })
      } else {
         
          this.message = "User "+ ActionMessage.SAVESUCCESS.toString();
          this.getPatients();
          this.clearData();
          this.isSuccessMessage  =true;
          this.hideMessage() ;
         
      }
      
     
    },
    error=>{
        this.loading = false;
        this.message = error._body.Message;
        this.isErrorMessage  =true;
        this.hideMessage() ;
    });
};
getPatients() : void {
  this.loading = true;
  this.message = "Refreshing patient data..";
  this._ptService.getPatients().subscribe(data=>{
    this.loading = false;
    this.message = "Refreshing patient data....";
    this.isSuccessMessage  =true;
    this.hideMessage() ;
    sessionStorage.setItem("data", JSON.stringify(data));
  },
  error=>{
      this.loading = false;
      this.message = error.data;
  });
}
clearData() : void {
  this.patient = new Patient(null,'','','','',null,'','','','','',null,null,'',null,'','','','',null,null,'');
  this.dobDate={};
  this.isAdd = true;
}
loadHistory() {
   this._hsSrv.getMedicalHistory().subscribe(data=>{
    this.history  = data;
  },
  error=>{
      this.message = error.data;
  });
}
  ngOnInit() {
    this.loadHistory();
  }
 ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/patient/create-patient/create-patient.component.ts